const rebuy_api_key = '2790460e3d34ff38a6dc014d3f7cabc4a19e8ddb';

class RebuyUpsells extends HTMLElement {
  constructor() {
    super();

    this.getProducts();

    this.parentSlider = this.parentElement.nodeName == 'SLIDER-COMPONENT' && this.parentElement;
  }

  getProducts() {
    const requestParameters = new URLSearchParams({
      shopify_product_ids: this.dataset.ids,
      limit: this.dataset.limit,
      key: rebuy_api_key
    });

    fetch(this.dataset.url + requestParameters)
      .then(response => response.json())
      .then(data => {
        let promiseArray = [];

        if (data.data) {
          for (const product of data.data) {
            promiseArray.push(fetch(`/products/${product.handle}?view=rebuy-upsell-card`).then(resp => resp.text()));
          }
  
          Promise.all(promiseArray).then(values => {
            let code = '';
  
            // render products to container
            for (const [index, value] of Object.entries(values)) {
              code += `
                <li id="Slide-${index}" class="grid__item slider__slide">
                  ${value}
                </li>
              `;
            }
   
            this.querySelector('ul.slider').innerHTML = code;
  
            // Call after all items have loaded
            if (this.parentSlider) {
              this.redefineSlider(data.data);
            }
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  redefineSlider(data) {
    if (data.length > 0) {
      let closestSlider = this.closest('slider-component');

      if (closestSlider) {
        let closestSliderBtns = closestSlider.querySelector('.slider-buttons');

        if (closestSliderBtns) {
          closestSliderBtns.classList.remove('hide');
        }
      }
    }

    this.parentSlider.sliderItems = this.parentSlider.querySelectorAll('[id^="Slide-"]');
    this.parentSlider.initPages()
  }
}

customElements.define('rebuy-upsells', RebuyUpsells);